import { Link } from "react-router-dom";

function NavigationRow({ className = "" }) {
  return (
    <nav className={`nav-row ${className}`.trim()}>
      <Link to="/" className="nav-link">
        Wheel
      </Link>
    </nav>
  );
}

export default NavigationRow;
